module.exports = __webpack_public_path__ + "img/1.813e49f6.jpg";